import { render } from "./internationalTourism.vue?vue&type=template&id=2f72209b&scoped=true"
import script from "./internationalTourism.vue?vue&type=script&lang=js"
export * from "./internationalTourism.vue?vue&type=script&lang=js"

import "./internationalTourism.vue?vue&type=style&index=0&id=2f72209b&scoped=true&lang=css"
import "./internationalTourism.vue?vue&type=style&index=1&id=2f72209b&scoped=true&lang=css"
import "./internationalTourism.vue?vue&type=style&index=2&id=2f72209b&scoped=true&lang=css"
import "./internationalTourism.vue?vue&type=style&index=3&id=2f72209b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f72209b"]])

export default __exports__